import React, { useState } from 'react';
import './Cart.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Cart = (props) => {
  const {Time} = props;
  const [Value, setValue] = useState([]);


  const addToBreak = (digit) =>{
    localStorage.setItem('break-time', JSON.stringify(digit));
   const newValue = localStorage.getItem("break-time");
   setValue(newValue);
  }

  const diffToast = () =>{
    toast("Congratulations Your Activity Completed....!", {position: "top-center",});
  }
  

  return (
    <div className='cart-body'>
      
    <div className='cart-img'>
    <img src="https://lh3.googleusercontent.com/a-/ACNPEu_v9FlvTS8162OWbC4dcOYLWYyt4_IzsmZcIi277g=s288-p-rw-no" alt="" />
      <div className='cart-text'>
      <h3>SHOUROV HASAN</h3>
      <p><small>Rajbari, Dhaka</small></p>
      </div>
    </div>
    <div className='my-info'>
        <div className='info-text'>
          <h3>60 <small>kg</small></h3>
            <p>Weight</p>
        </div>
        <div className='info-text'>
          <h3>6.8 <small>inch</small></h3>
          <p>Height</p>
        </div>
        <div className='info-text'>
          <h3>25 <small>yrs</small></h3>
          <p>Age</p>
        </div>
      </div>

      <div>
      <h2>Add A Break</h2>
      <div className='cart-btn'>       
          <button onClick={() => addToBreak(10)}>10m</button>
          <button onClick={() => addToBreak(20)}>20m</button>
          <button onClick={() => addToBreak(30)}>30m</button>
          <button onClick={() => addToBreak(60)}>60m</button>
        </div>

      </div>
      <div className='details'>
        <h2>Exercise Details</h2>
        <p>Exercise time: {Time} <small>min</small></p>
        <p>Break time: {Value} <small>min</small></p>
      </div>
      <button className='complete-btn' onClick={diffToast}>Activity Completed</button>
      <ToastContainer />
    </div>
  );
};

export default Cart;